var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ dark: _vm.theme === 'dark' },attrs:{"id":"app"}},[_c('Navigation'),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1),_c('Soundtrack')],1)}
var staticRenderFns = []

export { render, staticRenderFns }